module.exports = __webpack_public_path__ + "img/19d47f9.jpg";